import { Box } from '@mui/material';
import { EEntityType, entityTypeToLink } from '@sharedInterfaces/globalEnums';
import type { ISkillLevelCompare } from '@sharedInterfaces/IOpportunity';
import SkillItem from '@src/App/Components/Items/EntityItems/SkillItem/SkillItem';
import React from 'react';

interface SkillsLevelCompareProps {
    skills: ISkillLevelCompare[];
    inDialog?: true;
    employeeId?: number;
    size: 'small' | 'medium';
    levelBadgeVariant?: 'segment' | 'chip' | 'progress' | 'arrow' | 'circle';
    skillContext?: 'covered' | 'missing';
}
/**
 * Compares the skill levels of two players.
 *
 * @param {SkillsLevelCompareProps} props - The props for SkillsLevelCompare
 *
 * @returns {JSX.Element} The JSX element representing the comparison result.
 */
function SkillsLevelCompare(props: SkillsLevelCompareProps) {
    const skills = props.skills.map((skill) => {
        const withoutLink = props.inDialog || skill.id === undefined;

        return (
            <SkillItem
                key={skill.title + skill.id}
                disableOverlay={withoutLink}
                title={skill.title}
                id={skill.id}
                level={skill.level}
                wantedLevel={skill.wantedLevel}
                employeeId={props.employeeId}
                levelBadgeVariant={props.levelBadgeVariant}
                skillContext={props.skillContext}
                onClick={!props.inDialog && skill.id ? entityTypeToLink(skill.id, EEntityType.SKILL) : undefined}
            />
        );
    });

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                columnGap: props.size === 'small' ? 1 : 1.25,
                rowGap: props.size === 'small' ? 0.5 : 1,
                justifyContent: 'center',
                border: props.inDialog ? 'none' : undefined,
                p: props.size === 'small' ? 0.25 : 0,
            }}
        >
            {skills}
        </Box>
    );
}

export default SkillsLevelCompare;
